import { render, staticRenderFns } from "./VVideos.vue?vue&type=template&id=0e4a6d3b"
import script from "./VVideos.vue?vue&type=script&lang=js"
export * from "./VVideos.vue?vue&type=script&lang=js"
import style0 from "./VVideos.vue?vue&type=style&index=0&id=0e4a6d3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports